const ReviewCard = ({ review, reviewerName, index, source }) => {
    return (
        <div key={index}>
            <p>{review}</p>
            <p className="mt-1 font-semibold">- <a href={source} target='_blank' className="underline mt-2">{reviewerName}</a></p>
        </div>
    )
}

export default ReviewCard;